module.exports = __webpack_public_path__ + "static/media/erbagold.7d5d2ef2.png";